import { z } from 'zod';

export const FeatureToggleValueSchema = z.string().or(z.number()).or(z.boolean()).or(z.object({}));

export type FeatureToggleValue = string | boolean | number;
